import { DatePickerSelectInput, TextInput } from 'components';

import SearchIcon from '@mui/icons-material/Search';
import { Grid, InputAdornment } from '@mui/material';

export const HistoricSearchBar: React.FC = () => {
  return (
    <Grid container spacing={2}>
      <Grid item>
        <TextInput
          size="small"
          name="vetName"
          variant="outlined"
          placeholder="Buscar tutor"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={2}>
        <DatePickerSelectInput
          size="small"
          name="startDate"
          label="Data Início"
        />
      </Grid>
      <Grid item xs={2}>
        <DatePickerSelectInput
          size="small"
          name="endDate"
          label="Data Término"
        />
      </Grid>
    </Grid>
  );
};